<div class="sidebar-box">

  <p class="f-14 font-weight-600 text-webbtree-green pointer" (click)="back()">
    <span><i class="fa-regular fa-arrow-left"></i></span> Exit
  </p>
  <div class="carousel-container">
    <div class="screen-label">
      <span><img src="../../../assets/resume-screening/screen-globe.svg" alt=""></span> <span> Screen </span> <span
        class="ai-text">AI</span>
    </div>
    <p class="f-18 font-weight-600 line-height-1 mb-3">Cut Screening Time by 90%. Hire Faster.</p>
    <div class="mb-3">
      <!-- <div class="diff-card">
          <div>
            <img src="../../../assets/resume-screening/Instant_Screening24-7_dual.svg" alt="" style="width: 40px; height: 40px;">
          </div>
          <div class="diff-card-content">
            <p>Bias-Free Ranking </p>
            <p>Fair, transparent evaluations every time.</p>
          </div>
        </div> -->
      <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel" data-interval="2000">
        <ol class="carousel-indicators">
          <li data-bs-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
          <li data-bs-target="#carouselExampleCaptions" data-slide-to="1"></li>
          <li data-bs-target="#carouselExampleCaptions" data-slide-to="2"></li>
          <li data-bs-target="#carouselExampleCaptions" data-slide-to="3"></li>
          <li data-bs-target="#carouselExampleCaptions" data-slide-to="4"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="diff-card">
                <div>
                  <img src="../../../assets/resume-screening/Instant_Screening24-7_dual.svg" alt="" style="width: 40px; height: 40px;">
                </div>
                <div class="diff-card-content">
                  <p>Instant Screening, 24/7 </p>
                  <p>Process resumes in minutes, not days.</p>
                </div>
              </div>

          </div>
          <div class="carousel-item">
            <div class="diff-card">
                <div>
                  <img src="../../../assets/resume-screening/Custom_Fit_Criteria_dual.svg" alt="" style="width: 40px; height: 40px;">
                </div>
                <div class="diff-card-content">
                  <p>Custom Fit Criteria </p>
                  <p>Define what matters most and let AI score accordingly.</p>
                </div>
              </div>

          </div>
          <div class="carousel-item">
            <div class="diff-card">
                <div>
                  <img src="../../../assets/resume-screening/ATS_Sync_dual.svg" alt="" style="width: 40px; height: 40px;">
                </div>
                <div class="diff-card-content">
                  <p>Integration</p>
                  <p>Two-way integration with 40+ ATS & CRM tools you already use.</p>
                </div>
              </div>

          </div>
          <div class="carousel-item">
            <div class="diff-card">
                <div>
                  <img src="../../../assets/resume-screening/Bias_Free_Ranking_dual.svg" alt="" style="width: 40px; height: 40px;">
                </div>
                <div class="diff-card-content">
                  <p>Bias-Free Ranking </p>
                  <p>Fair, transparent evaluations every time.</p>
                </div>
              </div>

          </div>
          <div class="carousel-item">
            <div class="diff-card">
                <div>
                  <img src="../../../assets/resume-screening/Built_to_Scale_dual.svg" alt="" style="width: 40px; height: 40px;">
                </div>
                <div class="diff-card-content">
                  <p>Built to Scale</p>
                  <p>Handle high-volume roles effortlessly.</p>
                </div>
              </div>

          </div>
        </div>
        <!-- <button data-testid="auto-app-sidebar-screen-button-1" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </button>
        <button data-testid="auto-app-sidebar-screen-button-2" class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </button> -->
      </div>
    </div>
  </div>
</div>
